<template>
    <div class="tablePage">
        <el-table
            stripe
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="headCellStyle"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50" />
            <el-table-column v-if='isSys' prop="scopeName" :label="$t('public.table_scope')" show-overflow-tooltip />
            <el-table-column prop="name" :label="$t('public.table_code')" show-overflow-tooltip width="200">
                <template #default="{ row }">
                    <i v-icon:theme="['displayscreenTypeConvert', row.type]"></i>
<!--                    <i v-icon:theme="['equiStatusConvert', row.status]"></i>-->
                    <el-popover placement="top-start" width="auto" trigger="hover">
                        <v-popoer :rowData="row" :typeWay="$attrs.sensorWay" />
                        <span slot="reference">
                            <span>{{ row.displayCode }}</span>
                        </span>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="timeCode" :label="$t('device.time_zone')" show-overflow-tooltip>
                <template #default="{ row }">
                    <span>{{ shiquFn(row.timeCode) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('public.table_desc')" show-overflow-tooltip />
            <el-table-column prop="optare" fixed='right' :label="$t('public.table_operation')" width="160" align="center">
                <template #default="{ row }">
                    <el-button
                        type="text"
                        size="small"
                        v-for="item in optareBtn"
                        :key="item.id"
                        :title="$t(item.id !== 4 ? item.title : row.alarmOn === 1 ? item.title1 : item.title2)"
                        :icon="item.id !== 4 ? item.icon : row.alarmOn === 1 ? item.icon2 : item.icon1"
                        @click="handle(item.method, row)"
                    ></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { displayscreenTypeConvert, equiStatusConvert, carrierTypeConvert, shiquArrayConvert } from '@/utils/convert'
import proper from '../components/Proper.vue'
import { getIsSys } from '@/utils/permission'
export default {
  props: ['loading', 'tableData', 'shiquArray'],
  computed: {
    isSys () {
      return getIsSys()
    }
  },
  components: {
    'v-popoer': proper
  },
  data () {
    return {
      displayscreenTypeConvert,
      equiStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.edit'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editFn'
        },
        {
          id: 2,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },
        {
          id: 4,
          title1: $t('integration.pause_alarm'),
          title2: $t('device.alarm_on'),
          icon1: 'iconfont icon-guanbibaojing',
          icon2: 'iconfont icon-baojing',
          vHas: [],
          method: 'stopAlarmFn'
        },
        {
          id: 5,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        }
      ]
    }
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    shiquFn (type) {
      let str = ''
      for (const item of this.shiquArray) {
        if (type === item.code) {
          // str = item.name
          str = $t(shiquArrayConvert(item.code))
          break
        }
      }
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>
